import BannerProjects from "../../components/bannerProjects";
import ComoFazemos from "../../components/comoFazemos";
import Rodape from "../../components/rodape";
import BusinessOtimize from "../../components/businessOtimize";
import BusinessBeneficios from "../../components/businessBeneficios";

function GestaoPortfolio() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-gestao-portfolio.png"
                title="/GESTÃO"
                titleBold="DE PORTFÓLIO"
                iconSrc="../assets/icone-projectiva-behub.png"
                iconAlt="Projectiva BeHub"
                iconText="be."
                iconTextBold="hub"
                descriptionBold=""
                description={
                    <>
                        Com a <span className="font-bold">priorização e alocação estratégica de recursos</span>, é
                        possível garantir <span className="font-bold">entregas efetivas</span> para os projetos e
                        visibilidade para as decisões, gerando <span className="font-bold">resultados de alto impacto.</span>
                    </>
                }
                footerText="VERTICAL PROJECTS | Business Agility"
                buttonText="Quero me conectar"
                buttonColor="from-[#4B3BDB] to-[#A002CB]"
                brand="behub"
            />
            <ComoFazemos
                title="Como fazemos?"
                cards={[
                    {
                        icon: "/assets/servicos/facilitacao_icon.svg",
                        iconHover: "/assets/servicos/facilitacao_icon.svg",
                        title: "Priorização estratégica",
                        text: "Nossos esforços seguem sempre alinhados aos objetivos estratégicos da empresa, guiando a priorização de recursos e projetos.",
                        glowColor: "#A002CB",
                    },
                    {
                        icon: "/assets/servicos/engajamento_icon.svg",
                        iconHover: "/assets/servicos/engajamento_icon.svg",
                        title: "Alocação eficiente",
                        text: "Garantimos que cada projeto receba o suporte necessário através da gestão estratégica da alocação de recursos, buscando otimizar tanto a qualidade quanto o impacto das entregas.",
                        glowColor: "#A002CB",
                    },
                    {
                        icon: "/assets/servicos/adocao_icon.svg",
                        iconHover: "/assets/servicos/adocao_icon.svg",
                        title: "Visibilidade e controle",
                        text: "Oferecemos uma visão transparente do portfólio, promovendo decisões estratégicas e o monitoramento constante do progresso, assegurando que os resultados estejam alinhados às expectativas.",
                        glowColor: "#A002CB",
                    },
                ]}
            />
            <BusinessOtimize
                backgroundImage="../assets/background_portfolio.png"
                title={
                    <>
                        Otimizamos a gestão de recursos para garantir
                        <br />
                        projetos de excelência com resultados de alto
                        <br />
                        <span className="font-inter-bold">impacto.</span>
                    </>
                }
                buttonText="Otimize seu negócio"
                buttonLink="#"
            />
            <BusinessBeneficios
                title="Benefícios"
                text={
                    <>
                        A gestão de portfólio traz uma série de benefícios
                        tangíveis para a organização.
                    </>
                }
                buttonText="Otimize seu negócio!"
                buttonLink="#"
                buttonActionText="Contratar"
                items={[
                    {
                        icon: "/assets/servicos/prioridades_icon_purple.svg",
                        title: "PRIORIDADES ALINHADAS",
                        description:
                            "Projetos e recursos focados nas metas estratégicas da empresa.",
                    },
                    {
                        icon: "/assets/servicos/resistencia_icon_purple.svg",
                        title: "EFICIÊNCIA AUMENTADA",
                        description:
                            "Recursos alocados de maneira otimizada, garantindo o melhor uso do tempo e orçamento.",
                    },
                    {
                        icon: "/assets/servicos/visibilidade_icon_purple.svg",
                        title: "VISIBILIDADE APRIMORADA",
                        description:
                            "Decisões baseadas em uma visão estratégica clara e abrangente sobre o portfólio.",
                    },
                    {
                        icon: "/assets/servicos/engajamento_icon_purple.svg",
                        title: "IMPACTO MAXIMIZADO",
                        description:
                            "Foco em projetos de alto valor agregado, assegurando resultados de alto impacto.",
                    },
                ]}
            />
            <Rodape />
        </>
    );
}

export default GestaoPortfolio;
